export default {
  isPlayGameModalOpen: false,
  isAcceptTermsModalOpen: false,
  isLostCodeModalOpen: false,
  msisdn: null,
  redemptionMsisdn: null,
  selectedCodeForRedemption: null,
  foundBonusImage: false,
  availableSpins: 0,
  topUpValue: 0,
  ppsOpenTutorial: false,
  isPhysicalPrizeModalOpen: false,
  modalPhysicalPrizeId: '',
  isPrizeSmsModalOpen: false,
  isPrizeDataModalOpen: false,
  isPrizeEuroModalOpen: false,
  isPrizeMinutesModalOpen: false,
  physicalPrizeResponse: '',
  isLoginModalOpen: false,
  password: null,
  loginResponse: null,
  accessToken: null,
  isRegisterModalOpen: false,
  pinResponse: null,
  authenticatePinResponse: null,
  hasPasswordResponse: null,
  createPasswordResponse: null,
  isForgotPasswordModalOpen: false,
  gameResponse: [],
  telcoInfo: [],
  gameFlowState: '',
  hasBeenAwarded: false,
  extraChance: false,
  physicalPrize: [],
  selectedTelcoReward: [],
  deliveryDetails: {},
  optOutModalOpen: false,
  optOutResponse: null,
  optInResponse: null,
  changePasswordModalOpen: false,
  physicalDisplayedPrize: {},
  compareCustomerPasswordResponse: null,
  changePasswordResponse: null,
  accountResponse: null,
  sumOfOpenActions: null,
  physicalPrizeWinners: [],
  lastMonthWinners: [],
  inGameFlow: null,
  telcoValidRewardIds: null,
  isCodeValidForRedeem: true,
  registerAsOptIn: false,
  isPromoBundleCR207: false,
  isPromoBundleCR208: false,
  isPromoBundleCR209: false,
  isPromoBundleIR405: false,
  checkMarketingConsentResponse: null,
  updateMarketingConsentResponse: null,
  registerMarketingConsentTemp: null,
  playChances: '0',
  playsCount: '0'
}



// WEBPACK FOOTER //
// ./src/store/state.js